import { render, staticRenderFns } from "./Failure.vue?vue&type=template&id=038e1d9d&"
import script from "./Failure.vue?vue&type=script&lang=js&"
export * from "./Failure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports